import React from 'react'
import { CalendarWidget } from '../../widgets/CalendarWidget'
import { QuickNotesWidget } from '../../widgets/QuickNotesWidget'
import { TaskDetailsWidget } from '../../../features/taskManagement'
import { GoalsHelpPanel } from '../../../features/goals'

interface RightSidebarContentProps {
  activeTabPath?: string
  activeLifeSpace: 'personal' | 'work' | 'home' | 'all'
}

/** Matches `/home/<lifeSpace>/goals` — the Ziele page. */
const GOALS_PATH_RE = /\/home\/(personal|work|home)\/goals$/

export const RightSidebarContent: React.FC<RightSidebarContentProps> = ({
  activeTabPath,
  activeLifeSpace
}) => {
  // Ziele page: the right sidebar becomes a static help/context panel
  // instead of widgets. Life space is read from the path so it stays
  // correct even when `activeLifeSpace` is 'all'.
  const goalsMatch = activeTabPath?.match(GOALS_PATH_RE)
  if (goalsMatch) {
    return <GoalsHelpPanel lifeSpace={goalsMatch[1] as 'personal' | 'work' | 'home'} />
  }

  // Determine which widgets to show based on active tab
  const getWidgetsForPath = (path?: string) => {
    if (!path) {
      return ['calendar', 'quicknotes']
    }

    // Overview pages - show calendar and notes
    if (path.includes('/overview')) {
      return ['calendar', 'quicknotes']
    }

    // Today pages - show calendar and task details
    if (path.includes('/today')) {
      return ['calendar', 'taskdetails']
    }

    // Personal pages - show notes and calendar
    if (path.includes('/personal')) {
      return ['quicknotes', 'calendar']
    }

    // Work pages - show task details and calendar
    if (path.includes('/work')) {
      return ['taskdetails', 'calendar']
    }

    // Home pages - show notes and calendar
    if (path.includes('/home/home')) {
      return ['quicknotes', 'calendar']
    }

    // Default
    return ['calendar', 'quicknotes']
  }

  const widgets = getWidgetsForPath(activeTabPath)

  return (
    <>
      {widgets.includes('calendar') && <CalendarWidget />}
      {widgets.includes('quicknotes') && <QuickNotesWidget activeLifeSpace={activeLifeSpace} />}
      {widgets.includes('taskdetails') && <TaskDetailsWidget lifeSpace={activeLifeSpace} />}
    </>
  )
}